import { render, staticRenderFns } from "./_second_header.vue?vue&type=template&id=f70d8842&lang=html&"
import script from "./_second_header.vue?vue&type=script&lang=js&"
export * from "./_second_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports